import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=6f4bf5b3&scoped=true&lang=html&"
import script from "./manager.vue?vue&type=script&lang=js&"
export * from "./manager.vue?vue&type=script&lang=js&"
import style0 from "./manager.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./manager.vue?vue&type=style&index=1&id=6f4bf5b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4bf5b3",
  null
  
)

export default component.exports